import script from "./SpecificationValidator.vue?vue&type=script&lang=js"
export * from "./SpecificationValidator.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__